function getBundleProductTitle(bundleProduct) {
  if (!bundleProduct) {
    return;
  }
  if (bundleProduct.variants?.length) {
    const selected = bundleProduct.variants?.find((v) => v.sku === bundleProduct.sku);
    if (!selected || !selected?.title) {
      return bundleProduct.title;
    }
    return `${bundleProduct.title} - ${selected.title}`;
  } else {
    return bundleProduct.title;
  }
}
export {
  getBundleProductTitle
};
//# sourceMappingURL=get-bundle-product-title.js.map
